const SettingBoothStyle = {
    main: {
        maxWidth: 'auto',
        flexDirection: 'column',
    },
    button: {
        display: 'block',
        margin: 'auto',
        '& input': {
            padding: '6px',
        },
    },
    table_main: {
        padding: '0 20px',
        minWidth: 700,
    },
    table: {
        minWidth: 650,
    },
    img: {
        maxHeight: 400,
        maxWidth: 400,
        height: 'auto',
        width: 'auto',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
};

export default SettingBoothStyle;
